define(['angular'], function(angular) {

var m = require('am');

m.factory('apps', [function() {
    var apps={
        portal: {
            class_name: '',
            name: 'Portal',
            url: '/n/',
            nav_icon: 'A'
        },
        ft: {
          class_name: 'ft',
          name: 'FineTune',
          url: '/n/ft/',
          nav_icon: 'f'
        },
        anchor: {
          class_name: 'ft',
          name: 'Anchor Scoring Tool',
          url: '/n/anchor/',
          nav_icon: 'K'
        },
        a21: {
          class_name: 'a21',
          name: 'Assessments21',
          url: '/teacher_reports_a21.php',
          nav_icon: 'a'
        },
        a21reporting: {
          class_name: 'a21reporting',
          name: 'Assessments21 Reports',
          url: '/n/a21reporting',
          nav_icon: 'a'
        },
        lc: {
          class_name: 'lc',
          name: 'Literary Companion',
          url: '/teacher_reports.php',
          nav_icon: 'l'
        },
        roster: {
          class_name: 'classes',
          name: 'Classes',
          url: '/teacher_start.php',
          nav_icon: 'c'
        },
        staff: {
          class_name: 'staff',
          name: 'Staff',
          url: '/n/staff',
          nav_icon: 'I'
        }
    };
    return apps;
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/app_metadata.js
 **/